import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorFallback from 'components/ErrorFallback';

export class ErrorBoundary extends Component {
  static getDerivedStateFromError(error) {
    console.error(error);
    return { error };
  }

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;
    if (error) {
      return <ErrorFallback error={error} />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  params: PropTypes.shape({}),
};

ErrorBoundary.defaultProps = {
  children: null,
  params: {},
};

export default Component => props => (
  <ErrorBoundary params={props?.params}>
    <Component {...props} />
  </ErrorBoundary>
);
